"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressManager = void 0;
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_redux_1 = require("react-redux");
var address_list_1 = require("../api/calls/user/address_list");
var add_user_address_1 = require("../api/calls/user/add_user_address");
var delete_address_1 = require("../api/calls/user/delete_address");
var main_1 = require("../reducers/slices/main");
var geocoding_1 = require("../utils/geocoding");
var personal_details_1 = require("../constants/personal_details");
var AddressManager = function (_a) {
    var selectedHomeAddress = _a.selectedHomeAddress, selectedPostalAddress = _a.selectedPostalAddress, onHomeAddressChange = _a.onHomeAddressChange, onPostalAddressChange = _a.onPostalAddressChange, _b = _a.homeErf, homeErf = _b === void 0 ? "" : _b, onHomeErfChange = _a.onHomeErfChange, homeAddressError = _a.homeAddressError, postalAddressError = _a.postalAddressError, homeErfError = _a.homeErfError, _c = _a.showHomeErf, showHomeErf = _c === void 0 ? true : _c, _d = _a.postalRequired, postalRequired = _d === void 0 ? false : _d;
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    // Saved addresses from LetsTrade
    var _e = (0, react_1.useState)([]), addressList = _e[0], setAddressList = _e[1];
    var _f = (0, react_1.useState)(true), isLoadingAddresses = _f[0], setIsLoadingAddresses = _f[1];
    // New address input state
    var _g = (0, react_1.useState)("search"), inputMode = _g[0], setInputMode = _g[1];
    var _h = (0, react_1.useState)(false), isAddingAddress = _h[0], setIsAddingAddress = _h[1];
    var _j = (0, react_1.useState)(personal_details_1.DEFAULT_ADDRESS_LABEL), newAddressLabel = _j[0], setNewAddressLabel = _j[1];
    var _k = (0, react_1.useState)(""), customLabel = _k[0], setCustomLabel = _k[1];
    var _l = (0, react_1.useState)(""), manualAddressText = _l[0], setManualAddressText = _l[1];
    var _m = (0, react_1.useState)(null), searchedAddress = _m[0], setSearchedAddress = _m[1];
    var _o = (0, react_1.useState)(false), isSavingAddress = _o[0], setIsSavingAddress = _o[1];
    var _p = (0, react_1.useState)(false), isGeocodingAddress = _p[0], setIsGeocodingAddress = _p[1];
    var _q = (0, react_1.useState)(""), newAddressLabelError = _q[0], setNewAddressLabelError = _q[1];
    // Delete state
    var _r = (0, react_1.useState)(null), deletingId = _r[0], setDeletingId = _r[1];
    // Fetch addresses on mount
    (0, react_1.useEffect)(function () {
        if (user === null || user === void 0 ? void 0 : user.integration_id) {
            fetchAddresses();
        }
    }, [user === null || user === void 0 ? void 0 : user.integration_id]);
    var fetchAddresses = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsLoadingAddresses(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, address_list_1.address_list)({
                            user_id: (_a = user === null || user === void 0 ? void 0 : user.integration_id) !== null && _a !== void 0 ? _a : "",
                        })];
                case 2:
                    response = _b.sent();
                    if (response.success) {
                        setAddressList(response.content.addresses || []);
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Error", messages: [response.message] }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error("Failed to fetch addresses:", error_1);
                    return [3 /*break*/, 4];
                case 4:
                    setIsLoadingAddresses(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSelectForHome = function (address) {
        var coords = (0, geocoding_1.parseCoordinates)(address.latitude, address.longitude);
        if (coords) {
            onHomeAddressChange({
                full_address: address.full_address,
                latitude: coords.lat,
                longitude: coords.lng,
                label: address.label,
                isNew: false,
            });
        }
        else {
            // No coordinates available, still select but with 0,0
            onHomeAddressChange({
                full_address: address.full_address,
                latitude: 0,
                longitude: 0,
                label: address.label,
                isNew: false,
            });
        }
    };
    var handleSelectForPostal = function (address) {
        var coords = (0, geocoding_1.parseCoordinates)(address.latitude, address.longitude);
        if (coords) {
            onPostalAddressChange({
                full_address: address.full_address,
                latitude: coords.lat,
                longitude: coords.lng,
                label: address.label,
                isNew: false,
            });
        }
        else {
            // For postal, can also just use the string
            onPostalAddressChange(address.full_address);
        }
    };
    var handleDeselectHome = function () {
        onHomeAddressChange(null);
    };
    var handleDeselectPostal = function () {
        onPostalAddressChange(null);
    };
    var isSelectedAsHome = function (address) {
        if (!selectedHomeAddress || typeof selectedHomeAddress === "string")
            return false;
        return selectedHomeAddress.full_address === address.full_address;
    };
    var isSelectedAsPostal = function (address) {
        if (!selectedPostalAddress)
            return false;
        if (typeof selectedPostalAddress === "string") {
            return selectedPostalAddress === address.full_address;
        }
        return selectedPostalAddress.full_address === address.full_address;
    };
    var handleSearchSelection = function (value) {
        var _a, _b, _c, _d;
        var coords = (0, geocoding_1.parseCoordinates)((_a = value.coordinates) === null || _a === void 0 ? void 0 : _a.lat, (_b = value.coordinates) === null || _b === void 0 ? void 0 : _b.lng);
        setSearchedAddress({
            full_address: value.fullAddress,
            latitude: (_c = coords === null || coords === void 0 ? void 0 : coords.lat) !== null && _c !== void 0 ? _c : 0,
            longitude: (_d = coords === null || coords === void 0 ? void 0 : coords.lng) !== null && _d !== void 0 ? _d : 0,
            isNew: true,
        });
    };
    var handleManualAddressGeocode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var coords;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!manualAddressText.trim())
                        return [2 /*return*/];
                    setIsGeocodingAddress(true);
                    return [4 /*yield*/, (0, geocoding_1.geocodeAddress)(manualAddressText)];
                case 1:
                    coords = _c.sent();
                    setIsGeocodingAddress(false);
                    setSearchedAddress({
                        full_address: manualAddressText,
                        latitude: (_a = coords === null || coords === void 0 ? void 0 : coords.lat) !== null && _a !== void 0 ? _a : 0,
                        longitude: (_b = coords === null || coords === void 0 ? void 0 : coords.lng) !== null && _b !== void 0 ? _b : 0,
                        isNew: true,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var getEffectiveLabel = function () {
        if (newAddressLabel === personal_details_1.OTHER_ADDRESS_LABEL) {
            return customLabel.trim() || personal_details_1.OTHER_ADDRESS_LABEL;
        }
        return newAddressLabel;
    };
    var handleSaveNewAddress = function () { return __awaiter(void 0, void 0, void 0, function () {
        var label, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchedAddress)
                        return [2 /*return*/];
                    label = getEffectiveLabel();
                    if (!label) {
                        setNewAddressLabelError("Please enter a label for this address");
                        return [2 /*return*/];
                    }
                    setNewAddressLabelError("");
                    setIsSavingAddress(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, (0, add_user_address_1.add_user_address)({
                            label: label,
                            full_address: searchedAddress.full_address,
                            latitude: searchedAddress.latitude.toString(),
                            longitude: searchedAddress.longitude.toString(),
                            is_residential: true,
                            complex_building_details: "",
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.success) return [3 /*break*/, 4];
                    // Refresh address list
                    return [4 /*yield*/, fetchAddresses()];
                case 3:
                    // Refresh address list
                    _a.sent();
                    // Reset form
                    setSearchedAddress(null);
                    setManualAddressText("");
                    setNewAddressLabel(personal_details_1.DEFAULT_ADDRESS_LABEL);
                    setCustomLabel("");
                    setIsAddingAddress(false);
                    return [3 /*break*/, 5];
                case 4:
                    dispatch((0, main_1.setMessageModal)({ title: "Error", messages: [response.message] }));
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_2 = _a.sent();
                    console.error("Failed to save address:", error_2);
                    dispatch((0, main_1.setMessageModal)({ title: "Error", messages: ["Failed to save address"] }));
                    return [3 /*break*/, 7];
                case 7:
                    setIsSavingAddress(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUseAndSave = function (forHome) { return __awaiter(void 0, void 0, void 0, function () {
        var label, response, addressWithLabel, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchedAddress)
                        return [2 /*return*/];
                    label = getEffectiveLabel();
                    if (!label) {
                        setNewAddressLabelError("Please select a label for this address");
                        return [2 /*return*/];
                    }
                    setNewAddressLabelError("");
                    setIsSavingAddress(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, (0, add_user_address_1.add_user_address)({
                            label: label,
                            full_address: searchedAddress.full_address,
                            latitude: searchedAddress.latitude.toString(),
                            longitude: searchedAddress.longitude.toString(),
                            is_residential: true,
                            complex_building_details: "",
                        })];
                case 2:
                    response = _a.sent();
                    if (!response.success) return [3 /*break*/, 4];
                    addressWithLabel = __assign(__assign({}, searchedAddress), { label: label });
                    // Set as home or postal
                    if (forHome) {
                        onHomeAddressChange(addressWithLabel);
                    }
                    else {
                        onPostalAddressChange(addressWithLabel);
                    }
                    // Refresh address list to show the new address
                    return [4 /*yield*/, fetchAddresses()];
                case 3:
                    // Refresh address list to show the new address
                    _a.sent();
                    // Reset form
                    setSearchedAddress(null);
                    setManualAddressText("");
                    setNewAddressLabel(personal_details_1.DEFAULT_ADDRESS_LABEL);
                    setCustomLabel("");
                    setIsAddingAddress(false);
                    return [3 /*break*/, 5];
                case 4:
                    dispatch((0, main_1.setMessageModal)({ title: "Error", messages: [response.message || "Failed to save address"] }));
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_3 = _a.sent();
                    console.error("Failed to save address:", error_3);
                    dispatch((0, main_1.setMessageModal)({ title: "Error", messages: ["Failed to save address"] }));
                    return [3 /*break*/, 7];
                case 7:
                    setIsSavingAddress(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteAddress = function (addressId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDeletingId(addressId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, (0, delete_address_1.delete_address)({ _id: addressId })];
                case 2:
                    response = _a.sent();
                    if (!response.success) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchAddresses()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    dispatch((0, main_1.setMessageModal)({ title: "Error", messages: [response.message] }));
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_4 = _a.sent();
                    console.error("Failed to delete address:", error_4);
                    return [3 /*break*/, 7];
                case 7:
                    setDeletingId(null);
                    return [2 /*return*/];
            }
        });
    }); };
    var getPostalDisplayText = function () {
        if (!selectedPostalAddress)
            return "";
        if (typeof selectedPostalAddress === "string")
            return selectedPostalAddress;
        return selectedPostalAddress.full_address;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement("div", { className: "flex flex-col gap-4 bg-gray-100 rounded-md p-4" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Your Saved Addresses", textColor: "text-black", size: "small", bold: true }),
            isLoadingAddresses ? (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Loading addresses...", size: "xsmall" })) : addressList.length === 0 ? (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "No saved addresses. Add one below.", size: "xsmall" })) : (react_1.default.createElement("div", { className: "flex flex-col gap-2" }, addressList.map(function (address, index) { return (react_1.default.createElement("div", { key: address._id || index, className: "".concat(index > 0 ? "border-t border-borders pt-2" : "", " flex flex-col gap-2") },
                react_1.default.createElement("div", { className: "flex flex-row items-center gap-2" },
                    react_1.default.createElement("div", { className: "flex-1" },
                        react_1.default.createElement("div", { className: "flex flex-row items-center gap-2" },
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: address.label, bold: true, textColor: "text-black", size: "xsmall" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "\u2022", size: "xsmall" }),
                            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: address.full_address, size: "xsmall" }))),
                    react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faTrash, backgroundColor: "bg-error", borderColor: "border-transparent", iconColor: "text-white", size: "xsmall", loading: deletingId === address._id, onClick: function () { return handleDeleteAddress(address._id); } })),
                react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                    react_1.default.createElement("button", { type: "button", className: "flex flex-row items-center gap-1 px-3 py-1 rounded-full text-xs transition-colors ".concat(isSelectedAsHome(address) ? "bg-primary text-white" : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"), onClick: function () {
                            if (isSelectedAsHome(address)) {
                                handleDeselectHome();
                            }
                            else {
                                handleSelectForHome(address);
                            }
                        } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faHome, className: "text-xs" }),
                        react_1.default.createElement("span", null, "Home"),
                        isSelectedAsHome(address) && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheckCircle, className: "text-xs" })),
                    react_1.default.createElement("button", { type: "button", className: "flex flex-row items-center gap-1 px-3 py-1 rounded-full text-xs transition-colors ".concat(isSelectedAsPostal(address) ? "bg-secondary text-white" : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"), onClick: function () {
                            if (isSelectedAsPostal(address)) {
                                handleDeselectPostal();
                            }
                            else {
                                handleSelectForPostal(address);
                            }
                        } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMailbox, className: "text-xs" }),
                        react_1.default.createElement("span", null, "Postal"),
                        isSelectedAsPostal(address) && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheckCircle, className: "text-xs" }))))); }))),
            (selectedHomeAddress || selectedPostalAddress) && (react_1.default.createElement("div", { className: "mt-2 p-2 bg-white rounded border border-gray-200" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Selected:", textColor: "text-black", size: "xsmall", bold: true }),
                selectedHomeAddress && typeof selectedHomeAddress !== "string" && (react_1.default.createElement("div", { className: "flex flex-row items-center gap-1 mt-1" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faHome, className: "text-primary text-xs" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Home: ".concat(selectedHomeAddress.full_address), size: "xsmall", textColor: "text-gray-700" }))),
                selectedPostalAddress && (react_1.default.createElement("div", { className: "flex flex-row items-center gap-1 mt-1" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMailbox, className: "text-secondary text-xs" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Postal: ".concat(getPostalDisplayText()), size: "xsmall", textColor: "text-gray-700" }))))),
            homeAddressError && react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: homeAddressError, size: "xsmall", textColor: "text-red-500" })),
        react_1.default.createElement("div", { className: "flex flex-col gap-4 bg-gray-100 rounded-md p-4" },
            react_1.default.createElement("div", { className: "flex flex-row items-center justify-between" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Or Add a New Address", textColor: "text-black", size: "small", bold: true }),
                !isAddingAddress && (react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faPlus, backgroundColor: "bg-primary", borderColor: "border-transparent", iconColor: "text-white", size: "xsmall", onClick: function () { return setIsAddingAddress(true); } }))),
            isAddingAddress && (react_1.default.createElement("div", { className: "flex flex-col gap-3" },
                react_1.default.createElement("div", { className: "flex flex-row gap-2" },
                    react_1.default.createElement("button", { type: "button", className: "flex flex-row items-center gap-1 px-3 py-2 rounded text-sm transition-colors ".concat(inputMode === "search" ? "bg-primary text-white" : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"), onClick: function () { return setInputMode("search"); } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faMapMarkerAlt }),
                        react_1.default.createElement("span", null, "Map Search")),
                    react_1.default.createElement("button", { type: "button", className: "flex flex-row items-center gap-1 px-3 py-2 rounded text-sm transition-colors ".concat(inputMode === "manual" ? "bg-primary text-white" : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"), onClick: function () { return setInputMode("manual"); } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faKeyboard }),
                        react_1.default.createElement("span", null, "Manual Entry"))),
                react_1.default.createElement("div", { className: "flex flex-col gap-2" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Address Label", size: "xsmall", textColor: "text-black" }),
                    react_1.default.createElement("div", { className: "flex flex-row flex-wrap gap-2" }, personal_details_1.ADDRESS_LABELS.map(function (option) { return (react_1.default.createElement("button", { key: option.value, type: "button", className: "px-3 py-1 rounded text-sm transition-colors ".concat(newAddressLabel === option.value ? "bg-secondary text-white" : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"), onClick: function () { return setNewAddressLabel(option.value); } }, option.label)); })),
                    newAddressLabel === personal_details_1.OTHER_ADDRESS_LABEL && (react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Custom Label", size: "small", value: customLabel, onChange: setCustomLabel, errorText: newAddressLabelError }))),
                inputMode === "search" ? (react_1.default.createElement(doshx_controls_web_1.AddressSearchControl, { letsTradeAPIUrl: process.env.LETS_TRADE_CLIENT_URL, required: true, placeholder: "Search for an address...", size: "small", onSelectionChange: handleSearchSelection })) : (react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Enter Address (type your full address)", size: "small", value: manualAddressText, onChange: setManualAddressText })),
                react_1.default.createElement("div", { className: "flex flex-row flex-wrap gap-3" },
                    inputMode === "manual" && manualAddressText.trim() && (react_1.default.createElement("div", { className: "w-fit" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: isGeocodingAddress ? "Finding location..." : "Use Location", size: "small", backgroundColor: "bg-secondary", loading: isGeocodingAddress, enabled: !isGeocodingAddress, onClick: handleManualAddressGeocode }))),
                    react_1.default.createElement("div", { className: "w-fit" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Cancel", size: "small", backgroundColor: "bg-gray-500", onClick: function () {
                                setIsAddingAddress(false);
                                setSearchedAddress(null);
                                setManualAddressText("");
                            } }))),
                searchedAddress && (react_1.default.createElement("div", { className: "p-3 bg-white rounded border border-primary" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "New Address:", size: "xsmall", textColor: "text-black", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: searchedAddress.full_address, size: "xsmall" }),
                    searchedAddress.latitude !== 0 && (react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Coordinates: ".concat(searchedAddress.latitude.toFixed(6), ", ").concat(searchedAddress.longitude.toFixed(6)), size: "xsmall", textColor: "text-gray-500" })),
                    react_1.default.createElement("div", { className: "flex flex-row flex-wrap gap-3 mt-3" },
                        react_1.default.createElement("div", { className: "w-fit" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Save to Address Book", size: "small", backgroundColor: "bg-secondary", loading: isSavingAddress, enabled: !isSavingAddress, onClick: handleSaveNewAddress })),
                        react_1.default.createElement("div", { className: "w-fit" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Use as Home", size: "small", backgroundColor: "bg-primary", loading: isSavingAddress, enabled: !isSavingAddress, onClick: function () { return handleUseAndSave(true); } })),
                        react_1.default.createElement("div", { className: "w-fit" },
                            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Use as Postal", size: "small", backgroundColor: "bg-primary", loading: isSavingAddress, enabled: !isSavingAddress, onClick: function () { return handleUseAndSave(false); } })))))))),
        showHomeErf && (react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Home/Erf Number (house number, erf number, unit number)", size: "small", value: homeErf, onChange: function (v) { return onHomeErfChange === null || onHomeErfChange === void 0 ? void 0 : onHomeErfChange(v); }, errorText: homeErfError })),
        postalRequired && !selectedPostalAddress && (react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Postal Address (or select from saved addresses above)", size: "small", value: "", onChange: function (v) { return onPostalAddressChange(v); }, errorText: postalAddressError }))));
};
exports.AddressManager = AddressManager;
exports.default = exports.AddressManager;
